import { render, staticRenderFns } from "./InicioEmpresa.vue?vue&type=template&id=3e451406&"
import script from "./InicioEmpresa.js?vue&type=script&lang=js&"
export * from "./InicioEmpresa.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports